module.exports = __webpack_public_path__ + "img/lock.c0dc21f4.svg";